<template>
  <v-dialog
    v-if="isOpen"
    v-model="isOpen"
    @keydown.esc="close"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Import flow</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="importNewFlow">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                v-model="name"
                label="Flow name"
                dense
                hide-details
                :rules="[
                  rules.rulesCharcacters50.required,
                  rules.rulesCharcacters50.min,
                  rules.rulesCharcacters50.max
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="importNewFlow">
            <v-col cols="12" sm="12" md="12" lg="12">
              <div>Description</div>
              <v-textarea
                v-model="description"
                class="textarea-input m-t-10"
                solo
                hide-details
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <input
                ref="file"
                type="file"
                accept=".json"
                @change="changeFile"
                hidden
              />
              <v-btn class="btn-secondary" text @click="selectFile"
                >Select file</v-btn
              >

              <span class="m-l-20">{{ file.name || 'No file selected' }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions class="v-card-action-padding m-t-15">
        <v-spacer></v-spacer>
        <v-btn class="btn-secondary" @click="close">Cancel</v-btn>
        <v-btn
          class="btn-primary"
          :disabled="Object.keys(data).length === 0"
          @click="save"
        >
          Import
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    importNewFlow: Boolean,
    rules: Object,
    isOpen: Boolean,
    errorMessage: String
  },
  data() {
    return {
      name: '',
      description: '',
      file: {},
      data: {}
    }
  },
  methods: {
    selectFile() {
      this.$refs.file.click()
    },
    async changeFile(e) {
      const files = e.target.files
      if (files[0]) {
        const file = files[0]
        if (file && file.type && file.type.includes('json')) {
          this.file = file
          this.readFile(file)
        } else {
          e.target.value = ''

          this.file = {}

          this.errorMessage = 'The format is not supported.'
        }
      }
    },
    readFile(file) {
      let reader = new FileReader()
      reader.onload = e => {
        try {
          this.data = JSON.parse(e.target.result)
        } catch {
          this.data = {}
        }
      }
      reader.readAsText(file)
    },
    save() {
      this.$emit('saveImport', {
        name: this.name,
        description: this.description,
        data: this.data
      })
    },
    close() {
      this.$emit('saveImport', null)
    }
  }
}
</script>

<style scoped lang="scss">
.v-card-text-padding {
  padding: 25px !important;
}
.v-card-action-padding {
  padding: 0 25px 22px 25px !important;
}
</style>
